import React, { ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = (): void => {
    logout();
    navigate('/login');
  };

  // Close sidebar when clicking overlay
  const handleOverlayClick = () => setSidebarOpen(false);

  return (
    <div className="flex bg-stake-bg text-gray-100 relative" style={{ height: '100dvh' }}>
      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black bg-opacity-50 md:hidden"
          onClick={handleOverlayClick}
        />
      )}
      <div className="flex-1 flex flex-col md:mr-64">
        <header className="sticky top-0 z-10 bg-stake-header shadow-md border-b border-stake-border">
          <div className="px-4 py-1 flex justify-between items-center">
            <div className="flex items-center gap-2">
              {/* Hamburger button for mobile */}
              <button
                className="md:hidden p-0 rounded hover:bg-dark-200 focus:outline-none focus:ring-2 focus:ring-stake-blue"
                onClick={() => setSidebarOpen(true)}
                aria-label="Open sidebar"
              >
                <Bars3Icon className="h-7 w-7 text-white" />
              </button>
              <img src="/icons8-world-cup-96.png" alt="trophy" className="h-5 w-5" />
              <h1 className="text-m font-bold text-white">מונדיאל 2026</h1>
              
            </div>
            <button
              onClick={handleLogout}
              className="px-4 py-1 rounded-md bg-stake-sidebar hover:bg-dark-200 text-sm font-medium text-white transition duration-150 ease-in-out"
            >
              להתנתק
            </button>
          </div>
        </header>
        <main className="flex-1 overflow-y-auto p-3 bg-stake-bg" style={{ paddingBottom: 'max(12px, env(safe-area-inset-bottom))' }}>
          {children}
        </main>
      </div>
      {/* Sidebar: always visible on md+, overlay on mobile */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
    </div>
  );
};

export default Layout; 